/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Toggle_TitleInputs */

const en_image_inspector_toggle_title = /** @type {(inputs: Image_Inspector_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle inspector (I)`)
};

const ar_image_inspector_toggle_title = /** @type {(inputs: Image_Inspector_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إظهار الفاحص أو إخفاؤه (I)`)
};

const bn_image_inspector_toggle_title = /** @type {(inputs: Image_Inspector_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইন্সপেক্টর দেখান বা লুকান (I)`)
};

const de_image_inspector_toggle_title = /** @type {(inputs: Image_Inspector_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspektor ein- oder ausblenden (I)`)
};

const es_image_inspector_toggle_title = /** @type {(inputs: Image_Inspector_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar u ocultar el inspector (I)`)
};

const fr_image_inspector_toggle_title = /** @type {(inputs: Image_Inspector_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher ou masquer l'inspecteur (I)`)
};

const pt_image_inspector_toggle_title = /** @type {(inputs: Image_Inspector_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar ou ocultar o inspetor (I)`)
};

const zh_image_inspector_toggle_title = /** @type {(inputs: Image_Inspector_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示或隐藏检查器 (I)`)
};

const tr_image_inspector_toggle_title = /** @type {(inputs: Image_Inspector_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denetçiyi göster veya gizle (I)`)
};

const ru_image_inspector_toggle_title = /** @type {(inputs: Image_Inspector_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать или скрыть инспектор (I)`)
};

const pl_image_inspector_toggle_title = /** @type {(inputs: Image_Inspector_Toggle_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokaż lub ukryj inspektor (I)`)
};

/**
* | output |
* | --- |
* | "Toggle inspector (I)" |
*
* @param {Image_Inspector_Toggle_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_toggle_title = /** @type {((inputs?: Image_Inspector_Toggle_TitleInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Toggle_TitleInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_toggle_title(inputs)
	if (locale === "bn") return bn_image_inspector_toggle_title(inputs)
	if (locale === "de") return de_image_inspector_toggle_title(inputs)
	if (locale === "es") return es_image_inspector_toggle_title(inputs)
	if (locale === "fr") return fr_image_inspector_toggle_title(inputs)
	if (locale === "pt") return pt_image_inspector_toggle_title(inputs)
	if (locale === "zh") return zh_image_inspector_toggle_title(inputs)
	if (locale === "tr") return tr_image_inspector_toggle_title(inputs)
	if (locale === "ru") return ru_image_inspector_toggle_title(inputs)
	if (locale === "pl") return pl_image_inspector_toggle_title(inputs)
	return en_image_inspector_toggle_title(inputs)
});